import {useMutation} from "@tanstack/react-query";
import {useApiRequest} from "../../../../../common/hooks/useApiRequest";
import {WordWithId} from "../../../../../common/types/words";
import {CreateWordFromLookup} from "../types/lookup_types";

export interface UseCreateWordFromLookupArgs {
    deckId: number | undefined;
}

export const useCreateWordFromLookup = ({deckId}: UseCreateWordFromLookupArgs) => {

    const {postRequest} = useApiRequest();

    const {mutateAsync: createWord, isPending: isCreatingWord} = useMutation({
        mutationFn: ({lemma, index}: { lemma: string, index: number }) =>
            postRequest<WordWithId, CreateWordFromLookup>(
                `dictionary/lookup/create-word`,
                {deckId: deckId!, lemma: lemma, result_index: index}
            ),
    });

    return {createWord, isCreatingWord};
};
